import { icons } from 'constants/assets';
import { useTranslation } from 'i18n/useTranslation';
import { Link } from 'react-router-dom';

export const RenderPowerButton = () => {
  const { navbarTranslations } = useTranslation();
  return (
    <div className="flex h-[64px] w-full items-center justify-center transition-all duration-200 hover:brightness-125">
      <div className="xs:px-4 border-image-power flex h-[52px] w-full rounded-md bg-power-button-gradient px-2 sm:h-[42px] lg:px-3">
        <Link
          to={import.meta.env.VITE_POWER_PROTOCOL_URL}
          className="flex flex-row items-center justify-center gap-2 font-poppins text-[17.5px] font-bold tracking-normal text-[#ECEAED] lg:text-[12.5px] xl:text-[17.5px]"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className='lg:hidden'>
            {navbarTranslations.power}
          </div>
        <img
          src={icons.powerIcon}
          alt="Power coin icon"
          className="size-[34px] sm:size-[24px]"
          />
        </Link>
      </div>
    </div>
  );
};
